import { useState } from "react";
import { ArrowLeft, ClipboardList, MapPinned, MessagesSquare } from "lucide-react";
import { BFTiles } from "./BFTiles";
import BFRouteNotesAdmin from "./BFRouteNotesAdmin";
import BFClientFind from "./BFClientFind";
import BFClientExport from "./BFClientExport";
import BFGpsWeek from "./BFGpsWeek";
import { GPS_ON } from "./BFDayGps";

const TILES = [
  { id: "obs", label: "Observații agenți", hint: "Ce au notat agenții după vizite, pe săptămâni și agenți", icon: MessagesSquare },
  { id: "fise", label: "Fișe clienți", hint: "Caută și deschide fișa oricărui salon, export Excel", icon: ClipboardList },
  { id: "traseu", label: "Raport traseu", hint: "Km, ore de plecare și sosire, traseul pe hartă", icon: MapPinned },
].map((s) => ({ ...s, img: `/admin-tiles/plan-${s.id}-3d.jpg` }));

export default function BFAdminPlan() {
  const [tab, setTab] = useState("");
  if (!tab) return <div data-testid="bf-admin-plan"><BFTiles badges={{}} onOpen={setTab} sections={TILES} /></div>;
  return (
    <div data-testid="bf-admin-plan">
      <div className="bf-plan-head">
        <button type="button" className="st-btn st-btn--ghost" onClick={() => setTab("")} data-testid="bf-admin-plan-back"><ArrowLeft size={14} /> Cadranele planificării</button>
        <nav className="bfa-sub-nav">{TILES.map((x) => <button key={x.id} type="button" className={tab === x.id ? "is-on" : ""} onClick={() => setTab(x.id)} data-testid={`bf-admin-plan-tab-${x.id}`}>{x.label}</button>)}</nav>
      </div>
      {tab === "obs" && <BFRouteNotesAdmin />}
      {tab === "fise" && <div className="bf-admin-plan-stack"><BFClientFind /><BFClientExport /></div>}
      {tab === "traseu" && (GPS_ON ? <BFGpsWeek /> : (
        <section className="invite-box" data-testid="bf-admin-traseu-off">
          <h3><MapPinned size={18} /> Raport traseu</h3>
          <p className="st-hint">Raportul de traseu este pregătit, dar GPS-ul agenților este oprit momentan. Când îl activăm, aici vezi pentru fiecare agent și zi ora plecării și a sosirii acasă, km parcurși, vizitele și traseul pe hartă.</p>
        </section>
      ))}
    </div>
  );
}
